import { Theme, createStyles } from '@material-ui/core';

export const styles = (theme: Theme) =>
  createStyles({
    paper: {
      padding: theme.spacing(1, 0),
    },
    list: {},
  });
